import { writable } from 'svelte/store';
import { derivedSynchronisableStore, synchronisablePageTypeStore } from '#stores/factories/synchronisablePageTypeStore.js';

export const synchronisableSelectedRatingsStore = synchronisablePageTypeStore([]);
export const derivedSelectedRatingsStore = derivedSynchronisableStore(synchronisableSelectedRatingsStore);

export const benchmarkSelectedTargetRatingsStore = writable([]);
